<template>
  <div>
    <b-card no-body class="orComponent">
      <b-tabs pills card vertical v-model="tabIndex">
        <b-tab v-if="this.permissionLevel < 3.5" :title="$t('fitComponents.components.FITOutstandingRequirement.createCase.title')" @click="initialize">
          <!-- Create Case -->
          <FITFormCard>
            <div slot="header">
              <h4>{{$t('fitComponents.components.FITOutstandingRequirement.createCase.header')}}</h4>
            </div>
            <div class="container py-3" slot="formBody">
              <FITTextRow v-bind="createCase.policyID"></FITTextRow>
              <FITTextRow v-bind="createCase.policyType"></FITTextRow>
              <FITTextInput class="font-weight-bold" v-bind="createCase.subject" v-model.trim="createCase.subject.value" :disabled="createCase.submit.status" :rule="{required:true}" vuexObject="createCase"></FITTextInput>
              <!-- {{$v.createCase.subject.value}} -->
              <FITTextarea class="font-weight-bold" v-bind="createCase.description" v-model="createCase.description.value" :disabled="createCase.submit.status" :rule="{required:true}" vuexObject="createCase"></FITTextarea>
              <!-- {{$v.createCase.description.value}} -->
              <div class="bottomBorder">
                <b-col :cols="this.size=='sm'?'12':'10'" class="px-0 ml-auto mb-4">
                  <FITFileUpload v-model="createCase.uploadedFiles" ref="createFileSection" :showUploadBtn='false' :disabled="createCase.submit.status"></FITFileUpload>
                </b-col>
              </div>
              <b-row>
                <FITButton class="ml-auto" v-bind="createCase.submit" @click="createORCase"></FITButton>
                <!-- {{$v.createCase.$invalid}} -->
              </b-row>
            </div>
          </FITFormCard>
        </b-tab>
        <!-- Case History -->
        <b-tab :title="$t('fitComponents.components.FITOutstandingRequirement.caseHistory.title')" @click="initialize('caseHistory')">
          <FITFormCard>
            <div slot="header">
              <h4>{{$t('fitComponents.components.FITOutstandingRequirement.caseHistory.header')}}</h4>
            </div>
            <div class="container py-2" slot="formBody">
              <div class=" row mx-0">
                <b-col>
                  <FITTextRow v-bind="caseHistory.policyID"></FITTextRow>
                  <FITTextRow v-bind="caseHistory.policyType"></FITTextRow>
                </b-col>
                <FITButton v-if="this.permissionLevel < 3.5" variant="primary" :text="$t('fitComponents.components.FITOutstandingRequirement.caseHistory.createBtn')" class="ml-auto" @click="tabIndex=0"></FITButton>
              </div>
              <b-table responsive striped hover v-bind="caseHistory.cases">
                <template slot="requirementSubject" slot-scope="row">
                  <span class="text-primary pointer" v-on:click="goCaseDetail(row.item.ID)">{{row.item.requirementSubject}}</span>
                </template>
                <template slot="createAgent" slot-scope="row">{{getAgentName(row.item)}}</template>
                <!--  <template slot="requirementStatus" slot-scope='row'>
                  {{getORSelectionTranslation('requirementStatus',row.item.requirementStatus)}}
                  </template> -->
              </b-table>
              <b-row v-if="caseHistory.cases.isEmpty" class=" mx-0 justify-content-center">
                <span class="d-block h5 ">{{$t('fitComponents.components.FITOutstandingRequirement.caseHistory.noDataMsg')}}</span>
              </b-row>
              <div class="row mx-0">
                <FITPagination class="ml-auto" v-model="caseHistory.pagination.value" v-bind="caseHistory.pagination" @input="updateOutstandingRequirement"></FITPagination>
              </div>
            </div>
          </FITFormCard>
        </b-tab>
        <!-- Case Details -->
        <b-tab v-if="!caseHistory.cases.isEmpty" :title="$t('fitComponents.components.FITOutstandingRequirement.caseDetail.title')" @click="initialize">
          <FITFormCard>
            <div slot="header">
              <h4>{{$t('fitComponents.components.FITOutstandingRequirement.caseDetail.header')}}</h4>
            </div>
            <div class="px-3 pb-3" slot="formBody">
              <b-row>
                <b-col cols="9">
                  <h4 class="py-3 bottomBorder">
                    {{$t('fitComponents.components.FITOutstandingRequirement.caseDetail.information')}}
                  </h4>
                  <b-container>
                    <b-row align-h="around">
                      <b-col cols="5">
                        <FITTextRow v-bind="caseDetail.subject"></FITTextRow>
                        <FITTextRow v-bind="caseDetail.caseID"></FITTextRow>
                        <FITTextRow v-bind="caseDetail.updateTime"></FITTextRow>
                      </b-col>
                      <b-col cols="5">
                        <!-- <FITTextRow v-bind="caseDetail.clientID"></FITTextRow> -->
                        <FITTextRow v-bind="caseDetail.createAgent"></FITTextRow>
                        <FITTextRow v-bind="caseDetail.createTime"></FITTextRow>
                        <FITTextRow v-bind="caseDetail.status" :content="getORSelectionTranslation('requirementStatus', caseDetail.status.content) "></FITTextRow>
                      </b-col>
                    </b-row>
                  </b-container>
                  <div class="row mx-0 bottomBorder">
                    <h4 class="py-3" style="margin:0px;">{{$t('fitComponents.components.FITOutstandingRequirement.caseDetail.correspondence')}}</h4>
                    <div class="ml-auto" v-if="caseDetail.status.content=='P'">
                      <FITButton v-if="!caseDetail.reply.status" class="FITORButton" :text="$t('fitComponents.components.FITOutstandingRequirement.caseDetail.replyBtn')" @click="caseDetail.reply.status = true"></FITButton>
                      <FITButton v-if="this.permissionLevel < 3.5 " class="FITORButton" :text="$t('fitComponents.components.FITOutstandingRequirement.caseDetail.closeBtn')" @click="caseAction('close')"></FITButton>
                      <FITButton v-if="this.permissionLevel < 3.5 " class="FITORButton" :text="$t('fitComponents.components.FITOutstandingRequirement.caseDetail.rejectBtn')" @click="caseAction('reject')"></FITButton>
                      <FITButton v-if="this.permissionLevel < 3.5 " class="FITORButton" :text="$t('fitComponents.components.FITOutstandingRequirement.caseDetail.acceptBtn')" @click="caseAction('accept')"></FITButton>
                    </div>
                  </div>
                  <b-container>
                    <div v-if="caseDetail.reply.status">
                      <b-row align-v="center">
                        <b-col cols="3" class="text-right">
                          <span :class="validationStyle" class="d-block font-weight-bold">{{$t('fitComponents.components.FITOutstandingRequirement.caseDetail.replyBtn') +" * "}}</span>
                        </b-col>
                        <b-col cols="9">
                          <FITTextarea vuexObject="caseDetail" style="padding:0px;" class="font-weight-bold" v-bind="caseDetail.reply" v-model="caseDetail.reply.content" :disabled="caseDetail.submitReply.status" :rule="{required:true}" @validation="setValidation('reply',$event)"></FITTextarea>
                          <!-- {{$v.caseDetail.reply.content}} -->
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col :cols="this.size=='sm'?'12':'9'" class=" ml-auto">
                          <FITFileUpload v-model="caseDetail.reply.uploadedFiles" ref="replyFiles" :showUploadBtn='false' :disabled="caseDetail.submitReply.status"></FITFileUpload>
                        </b-col>
                      </b-row>
                      <b-row class="mx-0">
                        <FITButton class="ml-auto" v-bind="caseDetail.submitReply" @click="caseReply"></FITButton>
                        <!-- {{$v.caseDetail.$invalid}} -->
                      </b-row>
                    </div>
                    <b-row class="py-2 mx-0" v-for="(responce,index) in caseDetail.comments">
                      <b-col cols="3" class="text-right">
                        <span class="d-block font-weight-bold">{{responce.name}}</span>
                        <span class="d-block">{{responce.updateTime}}</span>
                      </b-col>
                      <b-col cols="9" class="p-4" :class="index == 0 ? 'latestResponce':'responceStyle'">
                        <span v-html="responce.content"></span>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
                <b-col cols="3">
                  <div>
                    <h4 class="py-3 bottomBorder">
                      {{$t('fitComponents.components.FITOutstandingRequirement.caseDetail.documents')}}
                    </h4>
                    <div class="container">
                      <span class="pointer d-block anchorLink" v-for="item in documents" @click="fileDownload(item.ID)">{{item.text}}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </FITFormCard>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script type="text/javascript">
import FITCheckbox from "./FITCheckbox.vue"
import FITTextInput from "./FITTextInput.vue"
import FITCheckboxGroup from "./FITCheckboxGroup.vue"
import FITRadio from "./FITRadio.vue"
import FITTextarea from "./FITTextarea.vue"
import FITSelect from "./FITSelect.vue"
import FITDatePicker from './FITDatePicker.vue'
import FITTimepicker from './FITTimepicker.vue'
import FITFormCard from './FITFormCard.vue'
import FITWorkflowProgressbar from './FITWorkflowProgressbar'
import FITvSelect from './FITvSelect.vue'
import FITPagination from './FITPagination.vue'
import FITTable from './FITTable.vue'
import FITFormGroup from './FITFormGroup.vue'
import FITModal from './FITModal.vue'
import FITAutoSearch from './FITAutoSearch.vue'
import FITFileUpload from './FITFileUpload.vue'
import FITInputTag from './FITInputTag.vue'
import FITOutstandingRequirement from './FITOutstandingRequirement.vue'
import FITTextRow from './FITTextRow.vue'
import FITButton from '../Button/FITButton.vue'

import { API, APIList } from '@/api'
import $ from 'jquery'
import FITValidationBus from './FITValidationBus'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FITOutstandingRequirement',
  components: {
    FITFormCard,
    FITRadio,
    FITSelect,
    FITFileUpload,
    FITTextInput,
    FITTextarea,
    FITTextRow,
    FITButton,
    FITTable,
    FITPagination
  },
  props: {
    accountType: {
      type: String,
      default: 'agent'
    },
    policyID: {
      type: [String, Number],
      required: true,
    },
    policyType: {
      type: String,
      required: true,
    },
    clientNumber: {
      type: String,
      default: '5712362',
    },
    size: {
      type: String,
      default: 'lg'
    },
    // agentName: {
    //   type: String,
    //   required: true
    // }
  },
  data() {
    return {
      tabIndex: 0,
      api: new APIList(),
      ORSelections: {
        status: false,
      },
      createCase: {

        policyID: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.ID'), content: this.policyID },
        policyType: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.type'), content: this.policyType },
        subject: { value: '', label: this.$t('fitComponents.components.FITOutstandingRequirement.general.subject')},
        description: { value: '', label: this.$t('fitComponents.components.FITOutstandingRequirement.createCase.description'), rows: 6, maxRows: 6 },
        submit: { variant: 'primary', text: this.$t('fitComponents.components.FITOutstandingRequirement.general.submitBtn'), faIcon: 'fa-send', status: false },
        uploadedFiles: {},
      },
      caseHistory: {
        policyType: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.type'), width: 9, content: this.policyType },
        policyID: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.ID'), width: 9, content: this.policyID },
        pagination: { value: 1, totalRows: 5, perPage: 5 },
        cases: {
          fields: [{
              key: 'lastUpdate',
              label: this.$t('fitComponents.components.FITOutstandingRequirement.general.lastUpdate'),
            },
            {
              key: 'requirementSubject',
              label: this.$t('fitComponents.components.FITOutstandingRequirement.general.subject')
            },
            {
              key: 'commentCount',
              label: this.$t('fitComponents.components.FITOutstandingRequirement.general.replys')
            },
            {
              key: 'createAgent',
              label: this.$t('fitComponents.components.FITOutstandingRequirement.general.createAgent')
            },
            // {
            //   key: 'clientNumber',
            //   label: this.$t('fitComponents.components.FITOutstandingRequirement.general.clientID')
            // },
            {
              key: 'requirementStatus',
              label: this.$t('fitComponents.components.FITOutstandingRequirement.general.status')
            },
          ],
          items: [],
          isEmpty: true,
        }
      },
      caseDetail: {
        currentCaseID: 1,
        clientID: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.clientID'), content: '', width: 8 },
        createAgent: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.createAgent'), content: '', width: 8 },
        createTime: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.createTime'), content: '', width: 8 },
        subject: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.subject'), content: '', width: 8 },
        caseID: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.caseID'), content: '', width: 8 },
        status: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.status'), content: '', width: 8 },
        updateTime: { label: this.$t('fitComponents.components.FITOutstandingRequirement.general.updateTime'), content: '', width: 8 },

        reply: { content: '', rows: 6, maxRows: 6, uploadedFiles: {}, status: false },
        submitReply: { variant: 'primary', text: this.$t('fitComponents.components.FITOutstandingRequirement.general.submitBtn'), faIcon: 'fa-send', status: false },
        comments: [],
      },
      documents: [],
      validator: {
        subject: null,
        description: null,
        reply: null
      },
    }
  },
  validations: {
    createCase: {
      subject: {
        value: {
          required
        }
      },
      description: {
        value: {
          required
        }
      }
    },
    caseDetail: {
      reply: {
        content: {
          required
        }
      }
    }
  },

  created() {
    this.updateOutstandingRequirement();
  },
  computed: {

    permissionLevel(){
      return this.$store.state.permissionLevel;
    },

    validationStyle() {
      if (this.validator.reply == null) { return; }
      if (this.validator.reply == true) { return 'form-valid'; }
      if (this.validator.reply == false) { return 'form-invalid'; }
    },
  },
  methods: {
    validationReset() {
      FITValidationBus.$emit('reset', true);
      this.validator.reply = null;
    },
    setValidation(key, value) {
      this.validator[key] = value;
      // console.log( key+": "+this.validator[key]);
    },
    createORCase() {
      FITValidationBus.$emit('dirty', 'createCase');
      if (this.$v.createCase.$invalid) {
        return;
      }
      if (confirm(this.$t('fitComponents.components.FITOutstandingRequirement.createCase.confirmMsg'))) {
        this.$refs.createFileSection.formUploadFiles();
        this.createCase.submit.status = true;
        var parameters = {
          policyID: this.policyID,
          policyType: this.policyType,
          requirementTypeCode: '03',
          clientNumber: this.clientNumber,
          requirementSubject: this.createCase.subject.value,
          requirementDescription: this.createCase.description.value,
          attachment: this.createCase.uploadedFiles.attachment,
          files: this.createCase.uploadedFiles.files,
        };
        // console.log(parameters);
        this.api.postOutstandingRequirement('create', parameters, (json) => {
            // console.log(json);
            if (json.status == 200) {
              // Jump to Latest Case Detail
              this.updateOutstandingRequirement();
              var vm = this;
              setTimeout(function() {
                vm.initialize();
                vm.$refs.createFileSection.initialize();
                vm.tabIndex = 2;
                vm.validationReset();
              }, 500);
              // reset Validation

            }
          },
          (error) => {
            console.error(error);
            alert(this.$t('fitComponents.components.FITOutstandingRequirement.createCase.errorMsg'));
          });

      }
    },
    caseReply() {
      FITValidationBus.$emit('dirty', 'caseDetail');

      if (this.$v.caseDetail.$invalid) {
        return;
      }
      if (confirm(this.$t('fitComponents.components.FITOutstandingRequirement.caseDetail.comfirmReplyMsg'))) {
        this.$refs.replyFiles.formUploadFiles();
        // console.log(this.caseDetail.reply.files);
        this.caseDetail.submitReply.status = true;
        var caseID = this.caseDetail.currentCaseID;
        var parameters = {
          policyID: this.policyID,
          policyType: this.policyType,
          outstandingRequirement: caseID,
          clientNumber: this.clientNumber,
          comments: this.caseDetail.reply.content,
          attachment: this.caseDetail.reply.uploadedFiles.attachment,
          files: this.caseDetail.reply.uploadedFiles.files,
        };
        // console.log(parameters);
        this.api.postOutstandingRequirement('comment', parameters, (json) => {
            // console.log(json);
            if (json.status == 200) {
              // Jump to Latest Case Detail
              this.getRequirementDetail(caseID);
              this.initialize();
              this.$refs.replyFiles.initialize();
              this.validationReset();
            }
          },
          (error) => {
            console.error(error);
            alert(this.$t('fitComponents.components.FITOutstandingRequirement.caseDetail.errorMsg'));
          });
      }
    },
    goCaseDetail(caseID) {
      this.caseDetail.currentCaseID = caseID;
      this.getRequirementDetail(caseID).then(() => {
          this.tabIndex = this.tabIndex + 1; // move to case detail
          this.initialize();
        })
        .catch((err) => {});
    },

    //  OR Data Update controller
    // async updateOutstandingRequirement() {
    //   var paras = [
    //     { key: 'type', value: this.policyType },
    //     { key: 'policyID', value: this.policyID },
    //     { key: 'count', value: this.caseHistory.pagination.perPage },
    //     { key: 'page', value: this.caseHistory.pagination.value },
    //   ];

    //   await this.getORSelection();

    //   this.api.getOutstandingRequirement('', paras, (json) => {
    //       if (parseInt(json.data.total) > 0) {
    //         this.caseHistory.cases.isEmpty = false;
    //         this.caseHistory.cases.items = json.data.list;
    //         for (var i = json.data.list.length - 1; i >= 0; i--) {
    //           this.caseHistory.cases.items[i].requirementStatus = this.getORSelectionTranslation(
    //             'requirementStatus', json.data.list[i].requirementStatus);
    //         }
    //         this.caseHistory.pagination.totalRows = json.data.total;
    //         // Show latest case detail
    //         if (this.caseHistory.pagination.value == 1) {
    //           this.caseDetail.currentCaseID = json.data.list[0].ID;
    //         }
    //         this.getRequirementDetail(this.caseDetail.currentCaseID);
    //       }

    //     },
    //     (error) => {
    //       console.error(error);
    //     });
    // },
    // async getRequirementDetail(ID) {
    //   var paras = [{ key: 'ID', value: ID }];
    //   new Promise((resolve, reject) => {
    //     this.api.getOutstandingRequirement('/detail', paras, (json) => {
    //         // console.log(json);
    //         if (json.status == 200) {
    //           this.caseDetail.clientID.content = json.data.clientNumber;
    //           var agentName = this.getAgentName(json.data);
    //           this.caseDetail.createAgent.content = agentName;
    //           this.caseDetail.createTime.content = json.data.createTime;
    //           this.caseDetail.subject.content = json.data.requirementSubject;
    //           this.caseDetail.caseID.content = json.data.ID;
    //           this.caseDetail.status.content = json.data.requirementStatus;
    //           this.caseDetail.updateTime.content = json.data.updateTime;

    //           // requirement
    //           this.caseDetail.comments = [];
    //           var requirement = {
    //             name: agentName,
    //             updateTime: json.data.createTime,
    //             content: json.data.requirementDescription
    //           };
    //           this.caseDetail.comments.push(requirement);

    //           // comments
    //           for (var i = json.data.comments.length - 1; i >= 0; i--) {
    //             let dataObj = json.data.comments[i];
    //             let comment = {};
    //             comment.name = this.getAgentName(dataObj);
    //             comment.updateTime = dataObj.lastUpdate;
    //             comment.content = dataObj.comments;
    //             this.caseDetail.comments.unshift(comment);
    //           }

    //           // Documents
    //           this.documents = [];
    //           for (var i = json.data.attachments.length - 1; i >= 0; i--) {
    //             let documentObj = json.data.attachments[i];
    //             let document = {};
    //             document.text = documentObj.documentName;
    //             document.ID = documentObj.ID;
    //             this.documents.unshift(document);
    //           }
    //           resolve();
    //         }
    //         reject();
    //       },
    //       (error) => {
    //         console.error(error);
    //         reject();
    //       });
    //   })

    // },

    fileDownload(ID) {
      this.api.fileDownload(ID);
    },
    caseAction(type) {

      if (confirm(this.$t('fitComponents.components.FITOutstandingRequirement.general.caseActionPrefix') + ' ' + type + ' ' + this.$t('fitComponents.components.FITOutstandingRequirement.general.caseActionPostfix') + ' ?')) {
        var parameters = { ID: this.caseDetail.currentCaseID };
        this.api.postOutstandingRequirement(type, parameters, (json) => {
          // console.log(json);
          this.getRequirementDetail(this.caseDetail.currentCaseID);

        }, (error) => {
          console.error(error);
        });

      }
    },
    initialize(page) {
      this.createCase.submit.status = false;
      this.caseDetail.submitReply.status = false;
      this.caseDetail.reply.status = false;
      // create
      this.createCase.subject.value = '';
      this.createCase.description.value = '';
      this.createCase.uploadedFiles = {};
      // reply
      this.caseDetail.reply.content = '';
      this.caseDetail.reply.files = {};
      if (page == 'caseHistory') {
        this.caseHistory.pagination.value = 1;
        this.updateOutstandingRequirement();
      }
    },
    getAgentName(data) {
      return data.agentChineseName + ' ' + data.agentEnglishName;
    },
    getORSelection() {
      this.api.getAllSelections('or', (json) => {
        // console.log(json);
        this.ORSelections.requirementStatus = json.data[1].options;
        this.ORSelections.policyType = json.data[0].options;
        this.ORSelections.status = true;
        this.updatePolicyType();
      }, (error) => {
        console.error(error);
      });
    },
    updatePolicyType() {
      var type = this.getORSelectionTranslation('policyType', this.policyType);
      this.createCase.policyType.content = type;
      this.caseHistory.policyType.content = type;

    },
    getORSelectionTranslation(key, value) {
      if (this.ORSelections[key]) {
        for (var i = 0; i <= this.ORSelections[key].length - 1; i++) {
          var obj = this.ORSelections[key][i];
          if (obj.selectionKey == value) {
            return this.translationFilter(obj);
          }
        }
      }
    },
    translationFilter(source) {
      let selection = '';
      switch (this.$i18n.locale) {
        case 'en_us':
          selection = source.selectionValueEnglish;
          break;
        case 'zh_cn':
          selection = source.selectionValueZhCn;
          break;
        case 'zh_hk':
          selection = source.selectionValueZhHk;
          break;
      }
      return selection;
    }

  }
}

</script>
<style type="text/css">
.orComponent a.nav-link.active {
  background: #007bff !important;
  color: white !important;
  font-weight: bold;
  text-align: left;
}

.orComponent a.nav-link {
  /*  border-radius: 0px !important;
*/
  text-align: left;
  font-size: 0.9rem;
  color: #007bff !important;
}

.latestResponce {
  background: #f1f9ff;
  border: solid 1px #ccc;
  white-space: pre-wrap;
}

.responceStyle {
  background: #f3f3f3;
  white-space: pre-wrap;
  border: solid 1px #ccc;
}

.FITORButton {
  background-color: #f2f2f2;
  background-image: linear-gradient(to bottom, #fff, #dedede);
  margin-bottom: 0.4rem !important;
  margin-right: 0.2rem;
  font-weight: 600 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Form/FITOutstandingRequirement.vue